module.exports = __webpack_public_path__ + "static/img/home-banners-mob3.e797b82d.jpg";